  import request from '@/utils/request'

/**
 * 创建租户公共信息
 */
export function createTenantPublicInfo(data) {
  return request({
    url: '/api/v1/admin/tenantPublicInfo',
    method: 'post',
    data
  })
}

/**
 * 更新租户公共信息
 */
export function updateTenantPublicInfo(id, data) {
  return request({
    url: `/api/v1/admin/tenantPublicInfo/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除租户公共信息
 */
export function deleteTenantPublicInfo(id) {
  return request({
    url: `/api/v1/admin/tenantPublicInfo/${id}`,
    method: 'delete'
  })
}

/**
 * 根据ID查询租户公共信息
 */
export function getTenantPublicInfoById(id) {
  return request({
    url: `/api/v1/admin/tenantPublicInfo/${id}`,
    method: 'get'
  })
}

/**
 * 根据租户ID查询租户公共信息
 */
export function getTenantPublicInfoByTenantId(tenantId) {
  return request({
    url: `/api/v1/admin/tenantPublicInfo/tenant/${tenantId}`,
    method: 'get'
  })
}

/**
 * 获取当前租户公共信息
 */
export function getCurrentTenantPublicInfo() {
  return request({
    url: '/api/v1/admin/tenantPublicInfo/currentPublicInfo',
    method: 'get'
  })
}

/**
 * 分页查询租户公共信息列表
 */
export function getTenantPublicInfoPage(params) {
  return request({
    url: '/api/v1/admin/tenantPublicInfo/page',
    method: 'get',
    params
  })
}

/**
 * 获取租户Logo上传凭证
 */
export function getTenantLogoUploadKey(params) {
  return request({
    url: '/api/v1/cos/admin/getPictureKey',
    method: 'get',
    params
  })
}

/**
 * 用fileKey取加签地址
 */
export function getSignUrl(fileKey) {
  return request({
    url: '/api/v1/cos/getSignUrl',
    method: 'get',
    params: { fileKey }
  })
}